import React from 'react';
import {Button, Checkbox, Modal, Table} from "antd";
import {injectIntl} from "react-intl";
import {withAuthorization} from "../../../services/Authorization";
import {connect} from "react-redux";
import BoldText from "../../common/text/BoldText";
import LabeledText from "../../common/text/LabeledText";
import SafesPlanningTable from "../../safes/planning/SafesPlanningTable";
import moment from "moment";
import Constants from "../../../services/Constants";

const Column = Table.Column;

class AssignSafeModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      safes: [],
      error: []
    }
  }

  componentDidMount() {
    const {type, intervention: {startDate, endDate}} = this.props;
    const fromDate = (type === Constants.DROPOFF_247) ? moment(startDate).subtract(1, 'days') : moment(endDate);
    this.setState({
      from: fromDate.format(Constants.DATE_FORMAT_API),
      to: fromDate.add(7, 'days').format(Constants.DATE_FORMAT_API),
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetchInterventionSafesPlanning) {
      const {safes} = nextProps.fetchInterventionSafesPlanning;
      this.setState({safes})
    }
  }

  fetchInterventionSafes = (page, size) => {
    const {intervention: {id}, type} = this.props;
    const {from, to} = this.state;
    this.props.dispatchFetchInterventionSafesPlanning(id, {page, size, from, to, type});
  };

  onDataUpdate = (page, size) => {
    this.fetchInterventionSafes(page, size)
  };

  onSave = () => {
    const {intervention: {id}, type} = this.props;
    const {selectedSafe} = this.state;

    if (selectedSafe) {
      this.props.dispatchAssignJourneySafe({assignType: type}, {interventionId: id, safeId: selectedSafe});
    } else {
      const errors = {interventionSafe: {message: 'error.non.selected.safe'}};
      this.setState({errors});
    }
  };

  onSelectSafe = (e, safe) => {
    const selectedSafe = e.target.checked ? safe.id : undefined;
    this.setState({selectedSafe, errors: undefined});
  };

  checkboxColumn = () => {
    return (
      <Column
        key="safe-selector"
        fixed="left"
        width={110}       // this value must be equals to other columns width to avoid rendering issues
        render={(text, record) => {
          const {selectedSafe} = this.state;
          const checked = record.dealerSafe.id === selectedSafe;
          return <Checkbox checked={checked} onChange={(e) => this.onSelectSafe(e, record.dealerSafe)}/>
        }}
      />
    )
  };

  render() {
    const {intl: {formatMessage}, onModalClose, visible, intervention: {customer, vehicle, journey: {rentalVehicle}}} = this.props;
    const {loading, totalElements} = this.props.fetchInterventionSafesPlanning;
    const {from, to, safes, errors} = this.state;

    return (
      <Modal title={formatMessage({id: 'section.safe-assignment.modal.title'})}
             visible={visible} onCancel={onModalClose} width={'100rem'}
             footer={[
               <Button key="save" type="primary" onClick={this.onSave}>{formatMessage({id: 'action.save'})}</Button>
             ]}>

        <div className="box__body--no-padding">
          <div className="row">
            <ul className="list col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id:'summary.customer'})}</h3>
              <li><LabeledText label={'summary.customer'} text={`${customer.firstName} ${customer.lastName}`}/></li>
              <li><LabeledText label={'summary.phone'} text={customer.phone}/></li>
              <li><LabeledText label={'vehicle.make'} text={vehicle.brand}/></li>
              <li><LabeledText label={'vehicle.model'} text={vehicle.model}/></li>
              <li><LabeledText label={'vehicle.vin'} text={<BoldText text={vehicle.vin} boldEndCharacters={7}/>}/></li>
              <li><LabeledText label={'vehicle.plate'} text={vehicle.licensePlate}/></li>
            </ul>

            {rentalVehicle &&
              <ul className="list col-md-6 col-xxl-6">
                <h3 className="box__subtitle">{formatMessage({id:'mobility.rental-car'})}</h3>
                <li><LabeledText label={'vehicle.make'} text={rentalVehicle.brand}/></li>
                <li><LabeledText label={'vehicle.model'} text={rentalVehicle.model}/></li>
                <li><LabeledText label={'vehicle.vin'} text={<BoldText text={rentalVehicle.vin} boldEndCharacters={7}/>}/></li>
                <li><LabeledText label={'vehicle.plate'} text={rentalVehicle.licensePlate}/></li>
              </ul>
            }
          </div>
          <br/>

          {errors && errors.interventionSafe &&
            <div className="alert alert--error">
              {formatMessage({id: errors.interventionSafe.message})}
            </div>
          }

          {/* This condition is necessary to "force" the component SafesPlanningTable to reload and make a new request */}
          {visible &&
            <SafesPlanningTable paging={true} safesPlanning={safes} loading={loading} totalElements={totalElements}
                                deactivateDates={true} onDataUpdate={this.onDataUpdate}
                                from={from} to={to} errors={errors} additionalColumns={this.checkboxColumn()}
                                pageSize={5} sizeOptions={["5", "10", "25", "50"]}/>
          }
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  fetchInterventionSafesPlanning: state.fetchInterventionSafesPlanning,
  assignJourneySafe: state.assignJourneySafe
});

const mapDispatchToProps = dispatch => ({
  dispatchAssignJourneySafe: (body, params) => dispatch({type: 'ASSIGN_JOURNEY_SAFE.REQUEST', body, params}),
  dispatchFetchInterventionSafesPlanning: (id, params) => dispatch({type: 'FETCH_INTERVENTION_SAFES_PLANNING.REQUEST', id, params})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(AssignSafeModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/interventiondetail/safe/AssignSafeModal.js